/* eslint semi: 1 */
import _ from 'lodash';

import PlayerSetupLicenseIcon from '../player-setup-license-icon/player-setup-license-icon-tmpl';

export const PLAYERS = [
  {
    type: 'DiVA',
    name: 'DIVA',
    icon: 'diva'
  },
  {
    type: 'DSOS',
    name: 'DSOS',
    icon: 'dsos'
  },
  {
    type: 'HMP300',
    name: 'HMP300',
    icon: 'hmp-300'
  },
  {
    type: 'HMP350',
    name: 'HMP350',
    icon: 'hmp-350'
  },
  {
    type: 'HMP400',
    name: 'HMP400',
    icon: 'hmp-400'
  },
  {
    type: 'HMP400W',
    name: 'HMP400W',
    icon: 'hmp-400w'
  },
  {
    type: 'iBX410',
    name: 'iBX410',
    icon: 'iBX-410'
  },
  {
    type: 'iBX410W',
    name: 'iBX410W',
    icon: 'iBX-410w'
  },
  {
    type: 'iBX440',
    name: 'iBX440',
    icon: 'iBX-440'
  }
];

export const PLAYER_DEFAULT_NAME = 'Player';
export const PLAYER_DEFAULT_ICON = '';
export const LICENSE_SYSTEMS = 'systems';
export const LICENSE_KIOSK = 'kiosk';
export const LICENSE_WIDGETS = 'widgets';

export default {
  name: 'playerIcon',
  components: { PlayerSetupLicenseIcon },
  props: {
    deviceType: {
      type: String,
      default () { return ''; }
    },
    licenses: {
      type: Array,
      default () { return []; }
    }
  },
  data () {
    return {
      name: PLAYER_DEFAULT_NAME,
      icon: PLAYER_DEFAULT_ICON,
      license: 'systems'
    };
  },
  watch: {
    deviceType (newValue) {
      this.setIcon(newValue);
    },
    licenses: {
      handler (newValue) {
        this.setLicense(newValue);
      },
      deep: true
    }
  },
  methods: {
    setIcon (deviceType = '') {
      const player = PLAYERS.find(player => player.type === deviceType);

      if (!_.isEmpty(player)) {
        this.name = player.name;
        this.icon = player.icon;
      } else {
        this.name = PLAYER_DEFAULT_NAME;
        this.icon = PLAYER_DEFAULT_ICON;
      }
    },
    setLicense (licenses = []) {
      /**
       * It is possible that player has multiple license but only one license should be visible in UI.
       * Priority
       * 1st: systems
       * 2nd: kiosk
       * 3rd: widgets
       */
      if (licenses.includes(LICENSE_SYSTEMS)) {
        this.license = LICENSE_SYSTEMS;
      } else if (licenses.includes(LICENSE_KIOSK)) {
        this.license = LICENSE_KIOSK;
      } else if (licenses.includes(LICENSE_WIDGETS)) {
        this.license = LICENSE_WIDGETS;
      } else {
        this.license = '';
      }
    }
  },
  mounted () {
    this.setIcon(this.deviceType);
    this.setLicense(this.licenses);
  }
};
